import React from 'react'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import SpotlioIcon from '../Icon';

import './index.scss';

export default ({ className, title, text = '', open, children, closeFn, footerContent, container, size = 'sm', withCloseButton = false, closeOnEscape = true, closeOnBackground = true }) => {
    let isOpen = open;

    return(
        <Dialog
            onEscapeKeyDown={closeOnEscape && closeFn}
            onBackdropClick={closeOnBackground && closeFn}
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={size}
            className={'generalDialog '+className}
            container={container || document.getElementsByClassName("main-application")[0]}
        >
            { withCloseButton && (
                <button className="close" onClick={closeFn}>
                    <SpotlioIcon icon="nav-close" />
                </button>
            ) }
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent id="alert-dialog-description">
                {
                    text !== ''
                    ?
                    <DialogContentText>{text}</DialogContentText>
                    :
                    null
                }
                {children}
            </DialogContent>
            <DialogActions>
                {footerContent}
            </DialogActions>
        </Dialog>
    );
}
